<template>
<div class="navbar-menu__submenu navbar-dropdown">
    <div class="container">
        <div class="columns navbar-menu__submenu__titles is-variable is-8">
            <div class="column is-narrow no-wrap navbar-menu__submenu__titles__title">{{item.title}}</div>
            <div class="column navbar-menu__submenu__titles__subtitle" v-html="item.subtitle"></div>
        </div>
        <div class="columns is-multiline navbar-menu__submenu__submenu is-variable is-8" v-if="item.sub.length">
            <div class="column is-4" v-for="subitem, n in item.sub">
                <router-link class="navbar-menu__submenu__submenu__item" :to="subitem.url" :key="'secondary-' + n">{{subitem.label}}</router-link>
                <ul class="navbar-menu__submenu__submenu__submenu">
                    <li v-for="tertiary, k in subitem.sub">
                        <router-link class="navbar-menu__submenu__submenu__submenu__item" :to="tertiary.url">{{tertiary.label}}</router-link>
                    </li>
                </ul>
            </div>
        </div>
    </div>
</div>
</template>

<script>
import ViewBlockItemMixin from '@/components/mixins/ViewBlockItemMixin';
export default {
    name    :   'NormalSubmenu',
    props   :   ['item'],
    mixins  :   [ ViewBlockItemMixin ],
}
</script>



// WEBPACK FOOTER //
// src/components/blocks/modules/elements/NormalSubmenu.vue